import { useCallback, useEffect, useState } from 'react';
import { reviewCommentsAdminApi } from '../api/admin/ReviewCommentsApi';
import { useAuth } from '../contexts/AuthContext';

/** Pending comment-review count for the sidebar and profile badges. */
export function usePendingReviewCommentCount() {
  const { user, isAuthenticated } = useAuth();
  const enabled = !!(
    isAuthenticated &&
    (user?.role === 'admin' ||
      user?.can_moderate_comments ||
      user?.canModerateComments)
  );
  const [count, setCount] = useState(0);

  const load = useCallback(async () => {
    if (!enabled) return;
    const res = await reviewCommentsAdminApi.list({
      page: 1,
      limit: 1,
      status: 'pending',
    });
    if (res.success && res.data) {
      setCount(res.data.pending_count ?? res.data.total ?? 0);
    }
  }, [enabled]);

  useEffect(() => {
    if (!enabled) return;
    queueMicrotask(() => {
      void load();
    });
    const onChange = () => {
      void load();
    };
    const onVisible = () => {
      if (document.visibilityState === 'visible') void load();
    };
    window.addEventListener('meraayurved:comment-moderation', onChange);
    window.addEventListener('focus', onChange);
    document.addEventListener('visibilitychange', onVisible);
    return () => {
      window.removeEventListener('meraayurved:comment-moderation', onChange);
      window.removeEventListener('focus', onChange);
      document.removeEventListener('visibilitychange', onVisible);
    };
  }, [enabled, load]);

  return enabled ? count : 0;
}
